import React, { Component } from 'react';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import MainBlock from '../../../components/blocks/MainBlock';

export default class Blocks extends Component {

    constructor(props) {
        super(props);

        this.blocks = [
            {
                title: "We design learning strategies",
                linkTarget: "#strategy",
                icon: "screenshot",
                text: (
                    <p>Is education your business? Do you want to scale through digital initiatives? Then TROI is your strategic partner to design the right programs and bring them to the market.</p>
                ),
                video: ""
            },
            {
                title: "We produce video content",
                linkTarget: "#content",
                icon: "education",
                text: (
                    <p>Are your video creation projects running on time and within budget? TROI’s ‘MOOCs and Courses in a Box’ process delivers full-service production and customised advisory services which guarantee results on time.</p>
                ),
                video: ""
            },
            {
                title: "We orchestrate GameTraining technology",
                linkTarget: "#technology",
                icon: "dashboard",
                text: (
                    <p>Are you reaching your target audience? Do they have the opportunity to learn and practice through digital role plays? TROI's developer team orchestrates technology to enable digital education.</p>
                ),
                video: ""
            }
        ];
    }

    render() {
        return (
            <BlockWrapper>
                {this.blocks.map((blockData, index) => (
                    <MainBlock key={index}
                        title={blockData.title}
                        linkTarget={blockData.linkTarget}
                        icon={blockData.icon}
                        text={blockData.text}
                        video={blockData.video}>
                    </MainBlock>
                ))}
            </BlockWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/parts/universities/Blocks.js